import { getGameInfoApi } from 'api/article'
import errorHandler from 'utils/errorHandler'

export default payload => async (dispatch) => {
  try {
    return await getGameInfoApi(payload)
  } catch (error) {
    return errorHandler(error)
  }
}
